// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlists_root__2Yrvd {\n  background: #fafafa;\n  display: flex;\n  justify-content: center;\n  height: 100%; }\n  .playlists_root__2Yrvd .playlists_content__4kMpV {\n    width: calc(100% - 60px);\n    height: calc(100% - 60px);\n    min-height: 300px;\n    padding: 20px;\n    background: #fff;\n    border-radius: 15px;\n    overflow: auto;\n    box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n    margin-top: 10px;\n    display: flex; }\n    .playlists_root__2Yrvd .playlists_content__4kMpV .playlists_leftSide__d21TH {\n      width: calc(100% - 380px); }\n    .playlists_root__2Yrvd .playlists_content__4kMpV .playlists_rightSide__2YngO {\n      width: 380px;\n      height: 100%; }\n", ""]);
// Exports
exports.locals = {
	"root": "playlists_root__2Yrvd",
	"content": "playlists_content__4kMpV",
	"leftSide": "playlists_leftSide__d21TH",
	"rightSide": "playlists_rightSide__2YngO"
};
module.exports = exports;
